import { Team } from "./model";
import { TeamAction } from "./actions";
import { LOAD_TEAMS_SUCCESS, CREATE_TEAM_SUCCESS, LOAD_TEAM_SUCCESS, SAVE_TEAM_SUCCESS } from "./actionTypes";

export function teams(state: Team[] = [], action: TeamAction) {
    switch (action.type) {
        case LOAD_TEAMS_SUCCESS:
            return action.payload;
        case SAVE_TEAM_SUCCESS:
        case LOAD_TEAM_SUCCESS:
            if (!state.find(t => t.id === action.payload.id)) {
                return [ ...state, action.payload ];
            }
            return state.map(t => team(t, action));
        case CREATE_TEAM_SUCCESS:
            return [ ...state, action.payload ];
        default:
            return state;
    }
}

function team(state: Team, action: TeamAction): Team {
    switch (action.type) {
        case SAVE_TEAM_SUCCESS:
        case LOAD_TEAM_SUCCESS:
            if (action.payload.id === state.id) {
                return action.payload;
            }
            return state;
        default:
            return state;
    }
}
